import {Controller} from "@hotwired/stimulus"

const STORAGE_KEY = "wind:last_menu"

export default class extends Controller {
    connect() {
        const url = new URL(window.location.href)
        const menu = (url.searchParams.get("menu") || "").trim()

        if (menu.length > 0) {
            this._set(menu)
            return
        }

        if (!this._isDashboardPath(url.pathname)) return

        const last = this._get()
        if (!last) return

        url.searchParams.set("menu", last)
        window.location.replace(url.toString())
    }

    remember(event) {
        const key = (event.currentTarget?.dataset?.menuKey || "").trim()
        if (key.length > 0) this._set(key)
    }

    clear() {
        try {
            window.localStorage.removeItem(STORAGE_KEY)
        } catch (_) {
        }
    }

    _isDashboardPath(pathname) {
        return pathname === "/" || pathname === "/dashboard"
    }

    _get() {
        try {
            return window.localStorage.getItem(STORAGE_KEY)
        } catch (_) {
            return null
        }
    }

    _set(value) {
        try {
            window.localStorage.setItem(STORAGE_KEY, value)
        } catch (_) {
        }
    }
}